export default __webpack_public_path__ + "static/media/icon robot_11747164.5043db3e.svg";